import { checkTransactionLoop } from '../../utils/common';
import { BuildModuleParamsType } from 'types/api-internal';
import {
  SugarMoneyApiPayoutProgressResponseType,
  SugarMoneyApiRequestPayoutResponseType,
  SugarMoneyApiSubmitPayoutRequestType,
  SugarMoneyTransactionStatusResponseType,
} from 'types/common';
import {
  SugarMoneyApiTicketsExchangeRateResponseType,
  SugarMoneyApiTicketsMaxAmountResponseType,
} from 'types/tickets';

export const ticketsModule = ({
  makeApiRequest,
  checkTransactionStatus,
}: BuildModuleParamsType) => ({
  maxAmount: async () =>
    makeApiRequest<SugarMoneyApiTicketsMaxAmountResponseType>({
      endpoint: 'tickets/max-amount',
      options: { method: 'get' },
    }),

  exchangeRate: async () =>
    makeApiRequest<SugarMoneyApiTicketsExchangeRateResponseType>({
      endpoint: 'tickets/exchange-rate',
      options: { method: 'get' },
    }),

  payout: {
    request: (data: { tickets: number }) =>
      makeApiRequest<SugarMoneyApiRequestPayoutResponseType>({
        endpoint: 'tickets/payout/request',
        data,
        options: { method: 'post' },
      }),
    submit: async (data: SugarMoneyApiSubmitPayoutRequestType) => {
      const response = await makeApiRequest<SugarMoneyTransactionStatusResponseType>({
        endpoint: 'tickets/payout/submit',
        data,
        options: { method: 'post' },
      });

      return checkTransactionLoop({
        signature: response.signature,
        checkTransactionStatus,
      });
    },

    inProgress: async () =>
      makeApiRequest<SugarMoneyApiPayoutProgressResponseType>({
        endpoint: 'tickets/payout/in-progress',
        options: { method: 'get' },
      }),
  },
});
